import ConfiguratorPrintsMainShapeType from './configuratorPrintsMainShapeType';
import ConfiguratorPrintsValidator from './../configuratorPrintsValidator';

const configuratorPrintsMainShapeParams = new Map();

configuratorPrintsMainShapeParams.set(ConfiguratorPrintsMainShapeType.Rect, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 1100],
        ['h', 700]
    ]),
    validator: ConfiguratorPrintsValidator.factory(ConfiguratorPrintsMainShapeType.Rect),
    validators: [
        model => model.w < 100 ? {propName: 'w', propValue: 100, message: ['configurator.errors.minimumWidth', {min: 100}]} : false,
        model => model.h < 100 ? {propName: 'h', propValue: 100, message: ['configurator.errors.minimumHeight', {min: 100}]} : false
    ]
});

configuratorPrintsMainShapeParams.set(ConfiguratorPrintsMainShapeType.Other, {
    defaults: new Map([
        ['x', 0],
        ['y', 0],
        ['w', 1100],
        ['h', 700]
    ]),
    validator: ConfiguratorPrintsValidator.factory(ConfiguratorPrintsMainShapeType.Other),
    validators: [
        model => model.w < 100 ? {propName: 'w', propValue: 100, message: ['configurator.errors.minimumWidth', {min: 100}]} : false,
        model => model.h < 100 ? {propName: 'h', propValue: 100, message: ['configurator.errors.minimumHeight', {min: 100}]} : false
    ]
});

export default configuratorPrintsMainShapeParams;
